// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CrZtXPOTC3LjWL {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: left;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding: 26px var(--ds-space-400, 32px) 26px var(--ds-space-600, 48px);
}
@media only screen and (max-width: 750px) {
  .CrZtXPOTC3LjWL {
    /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
    padding: 26px var(--ds-space-400, 32px);
  }
}
.W7oVMb9Kx6n2OU {
  margin: var(--ds-space-0, 0) var(--ds-space-600, 48px);
}
@media only screen and (max-width: 750px) {
  .W7oVMb9Kx6n2OU {
    margin: var(--ds-space-0, 0) var(--ds-space-400, 32px);
  }
}
`, ""]);
// Exports
export var headerWrapperMember = `CrZtXPOTC3LjWL`;
export var tabWrapper = `W7oVMb9Kx6n2OU`;
export default ___CSS_LOADER_EXPORT___;
